export default __webpack_public_path__ + "media/music/0b4264431c91653ffedd1f0034aa4c39.mp3";